import React, { useImperativeHandle } from 'react';
import './invite-form.sass';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Input } from '../../../../components/interface/input/input';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import buttonIcon from '../../assets/plus_button.png';
import { useDispatch, useSelector } from 'react-redux';
import { createVendorUsers } from '../../configuration.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { Config } from '../../../../config/config';
import { getTeamVendorId } from '../../../login/session.slice';
import { TeamRole } from '../../../../model/teamRole';

const FormSchema = Yup.object({
    users: Yup.array().of(Yup.object().shape({
        firstName: Yup.string().when('email',{
            is: (value) => !!value,
            then: Yup.string().max(50, 'Za długie!').min(3, 'Za krótkie!').required('Pole wymagane !')
        }),
        email: Yup.string().when('firstName',{
            is: (value) => !!value,
            then: Yup.string().email('Podaj poprawny format email').required('Pole wymagane !')
        }),
    }, [['email', 'firstName']])),
});
/* eslint-disable react/display-name */
export const InviteForm = React.forwardRef(({onSuccess}, ref) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const sessionData = useSelector(state => state.session);
    const vendorId = getTeamVendorId(sessionData);

    const formik = useFormik({
        initialValues: {
            users: [
                {
                    firstName: '',
                    lastName: '?',
                    email: '',
                    roles: [
                        TeamRole.ROLE_VENDOR_HANDLER
                    ]
                }
            ],
        },
        validationSchema: FormSchema,
        onSubmit: (values) => {
            values.users = values.users.filter(member => member.email !== '' && member.firstName !== '');
            if (values.users.length > 0) {
                dispatch(createVendorUsers({...values, id: vendorId}))
                    .then(unwrapResult).then(() => {
                    toast.success('formularz wysłany');
                    history.push(Config.routePaths.main.vendor.dashboard.profile.path);
                }, () => {
                    toast.error('coś poszło nie tak');
                })
                    .catch(e => {
                        toast.error(e.message);
                    });
            }
            history.push(Config.routePaths.main.vendor.dashboard.profile.path);
        }
    });

    const startFn = () => {
        formik.submitForm();
    };

    useImperativeHandle(ref, () => ({
        start:  startFn
    }));

    const handleButtonClick = () => {
        formik.setValues({...formik.values, users: [...formik.values.users, {firstName: '', lastName: '?', email: '', roles: [TeamRole.ROLE_VENDOR_HANDLER]}]});
    };

    const deleteMember = (index) => {
        formik.values.users.splice(index, 1);
        formik.setValues({...formik.values, users: formik.values.users});
    };

    return (
        <div ref={ref} className='vv-vendor-invite-form-container'>
                <div className='vv-vendor-invite-form'>
                    <div className='vv-vendor-invite-form__info'>
                        <p>Wyślij zaproszenie swoim pracownikom do aplikacji <span>Viceversa płatności</span>. Wszystkie pobrane aplikacje będą powiązane z Twoim kontem.</p>
                    </div>
                    {
                        formik.values.users.map((member, i) =>
                            <form key={i} onSubmit={formik.handleSubmit}>
                                <div key={i} className='vv-vendor-invite-form__input'>
                                    <div className='input-margin'>
                                        <Input label='Imię i nazwisko' onBlur={formik.handleBlur}
                                               onChange={formik.handleChange}
                                               name={`users[${i}].firstName`} id={`users.${i}.firstName`}
                                               value={formik.values.users[i].firstName}
                                               textError={formik.touched.users?.[i]?.firstName && formik.errors.users?.[i]?.firstName}
                                        />
                                    </div>
                                    <Input label='Email' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                           name={`users[${i}].email`} id={`users.${i}.email`}
                                           value={formik.values.users[i].email}
                                           textError={formik.touched.users?.[i]?.email && formik.errors.users?.[i]?.email}
                                    />
                                    {
                                        i !== 0 ?
                                            <div className='delete-button'>
                                                <span id={`users.${i}.delete`} onClick={() => deleteMember(i)}>x</span>
                                            </div>
                                            :
                                            <div className='delete-button'/>

                                    }
                                </div>
                            </form>
                        )
                    }
                    <div className='vv-vendor-invite-form__button'>
                        <Button type='button' text='Dodaj kolejne' size={ButtonSize.NO_PADDING} buttonType={ButtonType.TRANSPARENT} iconLeft={buttonIcon} color={'#3AC974'} onClick={handleButtonClick}/>
                    </div>
                </div>
        </div>
    );
});
